.container {
  display: flex;
  flex-direction: column;

  @media screen and (min-width: $bp-small) {
    gap: 0.8rem;
  }
}

.contact-search-bar-wrapper {
  margin: 1.6rem 0;

  input {
    font-weight: 400;
    font-size: 1.2rem;
  }

  svg {
    width: 1.6rem;
    color: var(--color-grayscale-shuttle);
  }
}
